import React, { useEffect, useState } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';

async function loadFile(path, signal) {
  const api = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  const res = await fetch(api + '/files/' + path.split('/').map(encodeURIComponent).join('/'), { headers: getAuthHeaders(), signal });
  if (!res.ok) throw new Error('This file is unavailable or you do not have access.');
  return res.blob();
}

export function ProtectedFileLink({ path, children = 'Download' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const download = async () => {
    setLoading(true); setError('');
    try {
      const url = URL.createObjectURL(await loadFile(path));
      const link = document.createElement('a'); link.href = url; link.download = path.split('/').pop(); link.click();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };
  return <span><button type="button" onClick={download} disabled={loading}>{loading ? 'Downloading…' : children}</button>{error && <small role="alert">{error}</small>}</span>;
}

export function ProtectedImage({ path, alt, onPreview, ...props }) {
  const [src, setSrc] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController(); let url;
    setSrc(''); setError('');
    loadFile(path, controller.signal).then(blob => {
      if (controller.signal.aborted) return;
      if (!blob.type.startsWith('image/')) throw new Error('Download this attachment to view it.');
      url = URL.createObjectURL(blob); setSrc(url);
    }).catch(e => { if (!controller.signal.aborted) setError(e.message); });
    return () => { controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (error) return <ProtectedFileLink path={path}>{alt || 'Download attachment'}</ProtectedFileLink>;
  return src ? <img {...props} src={src} alt={alt} onClick={() => onPreview?.(src)} /> : <span>Loading image…</span>;
}
